/**
      *********************************************************
      Description: Hanldes text. different types- dtext, datetimetext. dtext handles dynamic text. datetimetext handles datetime text.
      Required props:  type.
      limitations    : N/A
      *********************************************************
**/

import React, { Component, Fragment } from 'react';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'

const CFormText = (props) => {
    const { options, style, type, value, edit } = props;
    const { text, error, label, ...otherOptions } = options ? options : { text: '' }
    let dvalue = null
    if (type === 'dtext') {
        if (value) {
            dvalue = <div className="row col"> <Typography variant={'subtitle2'} color={error ? 'secondary' : 'primary'}>{text} </Typography>&nbsp;
             <Typography variant={'body2'} color={error ? 'secondary' : 'textPrimary'}>{value ? value : ''}  </Typography></div>
        }
       // else dvalue = text + (value ? value : "")
      //  else dvalue = <div className="row col"> <Typography variant={'subtitle2'} color={error ? 'secondary' : 'primary'}>{text} </Typography>&nbsp; <Typography variant={'body2'} color={error ? 'secondary' : 'textPrimary'}>{value ? value : ''}  </Typography></div>
    }
    if (type === 'etext') dvalue= (value ? value : "")
    if (type === 'datetimetext') dvalue = (value ? value : "")
    if (type === 'cformtext') dvalue = (value ? value : "")

    return (
        <Fragment>
            <Typography style={style} {...otherOptions}>
                {(type === 'text') && <div className="row ps-3">{label}</div>}
                {(type === 'etext') && <div className="row col pt-3" style={{color:'#f50057'}}>{dvalue === null ? '' : dvalue}</div>}
                {(type === 'dtext') && <div className="row col">{dvalue === null ? '' : dvalue}</div>}
                {(type === 'datetimetext' && value != null) && <div className={!edit ? "row" : "row col"}> <Typography variant={'caption'} className="text-secondary">{label} </Typography>&nbsp; <Typography  variant={'body2'} color={'textPrimary'}  className="fw-bold">{moment(value).format('MM/DD/YYYY hh:mm:ss A') === "Invalid date" ? '' : moment(value).format('MM/DD/YYYY hh:mm:ss A') }  </Typography>
                </div>}
                {(type === 'cformtext') && <div className={!edit ? "row" : "row col"}> <Typography variant={'caption'} className="text-secondary">{label} : </Typography>&nbsp; <Typography  variant={'body2'} color={'textPrimary'}  className="fw-bold">{dvalue }  </Typography>
                </div>}
            </Typography>
        </Fragment>
    )

}



export default CFormText;




/**
 * {
 * type:'title',
 * options:{
 *  text:'',
 * },
 * defaults:{
 * layout:'material',
 * customlayout: false
 * }
 * }
 */
